import Vue from 'vue';

import Avatar from './components/Avatar/Avatar.vue';
import AvatarNested from './components/AvatarNested.vue';
import SwitchToggle from './components/SwitchToggle.vue';
import CustomToast from './components/CustomToast.vue';
import BootstrapVue from 'bootstrap-vue';
import VueFlatPickr from 'vue-flatpickr-component';
import Stepper from './components/Stepper.vue';
import Step from './components/Step.vue';
import VerticalStepper from './components/VerticalStepper/VerticalStepper.vue';
import Tab from './components/VerticalStepper/Tab.vue';
import Map from './components/Map/Map.vue';
import MarkerInfoWindow from './components/MarkerInfoWindow.vue';
import Sidebar from './components/Sidebar/Sidebar.vue';
import Hamburger from './components/Sidebar/Hamburger.vue';
import StepLink1 from './components/Steppers/1/StepLink1.vue';
import StepsWrapper1 from './components/Steppers/1/StepsWrapper1.vue';
import StepsWrapper2 from './components/Steppers/2/StepsWrapper2.vue';
import StepLink2 from './components/Steppers/2/StepLink2.vue';
import Increment from './components/Increment/Increment.vue';
import Dropzone from './components/Dropzone/Dropzone.vue';
import CustomSelect from './components/CustomSelect/CustomSelect.vue';
import DragAndDrop from './components/DragAndDrop/DragAndDrop.vue';
import FileCard from './components/DragAndDrop/FileCard.vue';
import FileThumbnail from './components/DragAndDrop/FileThumbnail.vue';
import EmptyDashedCard from './components/Card/EmptyDashedCard/EmptyDashedCard.vue';
import BadgeLoadingPlaceholder from './components/LoadingPlaceholder/Badge/BadgeLoadingPlaceholder.vue';
import ImageLoadingPlaceholder from './components/LoadingPlaceholder/Image/ImageLoadingPlaceholder.vue';
import TextLoadingPlaceholder from './components/LoadingPlaceholder/Text/TextLoadingPlaceholder.vue';
import ElementLoader from './components/ElementLoader/ElementLoader.vue';
import DefaultUserIcon from './components/DefaultUserIcon/DefaultUserIcon.vue';
import CommonSidebar from './components/Common/CommonSidebar/CommonSidebar.vue';
import CommonHeader from './components/Common/CommonHeader/CommonHeader.vue';
import AnimateHamburger from './components/AnimateHamburger/AnimateHamburger.vue';
import LazyPublicStorageImage from './components/LazyPublicStorageImage/LazyPublicStorageImage.vue';
import ModalFullWidth from './components/ModalFullWidth/ModalFullWidth.vue';
import AddMore from './components/AddMore/AddMore.vue';

//Inputs
import PriceInput from './components/Inputs/PriceInput/PriceInput.vue';
import TextInput from './components/Inputs/TextInput/TextInput.vue';
import MsDatePicker from './components/Inputs/MsDatePicker/MsDatePicker.vue';
import PhoneInput from './components/Inputs/PhoneInput/PhoneInput.vue';
import UsPhoneInput from './components/Inputs/UsPhoneInput/UsPhoneInput.vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import {BootstrapVueConfig} from './helpers/bootstrapVueConfig';


import './helpers';
import registerVueFilters from './helpers/filters';

registerVueFilters(Vue);


// Note: Add here all Custom Components of the WsUiKitLibrary
const components = {
    Avatar,
    AvatarNested,
    SwitchToggle,
    Step,
    CustomToast,
    Stepper,
    VerticalStepper,
    Tab,
    Map,
    MarkerInfoWindow,
    Sidebar,
    Hamburger,
    StepLink1,
    StepsWrapper1,
    StepsWrapper2,
    StepLink2,
    Increment,
    Dropzone,
    CustomSelect,
    DragAndDrop,
    FileCard,
    FileThumbnail,
    EmptyDashedCard,
    BadgeLoadingPlaceholder,
    ImageLoadingPlaceholder,
    TextLoadingPlaceholder,
    ElementLoader,
    DefaultUserIcon,
    CommonSidebar,
    CommonHeader,
    AnimateHamburger,
    LazyPublicStorageImage,

    //Inputs
    MsDatePicker,
    TextInput,
    PriceInput,
    PhoneInput,
    UsPhoneInput,
    ModalFullWidth,
    AddMore,
};

const WsUiKitLibrary = {
    ...components,
    install(Vue, options = {}) {
        Vue.use(VueAwesomeSwiper);
        if (options.hasOwnProperty('includeBootstrap') && options.includeBootstrap) {
            Vue.use(BootstrapVue, BootstrapVueConfig);
            Vue.use(VueFlatPickr);
        }

        // Register all custom components
        for (const componentName in components) {
            Vue.component(componentName, components[componentName]);
        }

        // Register filters
        registerVueFilters(Vue);

        Vue.prototype.$uiBus = new Vue();
    },
};

export default WsUiKitLibrary;

// Note: Add here all Custom Components of the WsUiKitLibrary
// Those will be used as individual components
export {
    Avatar,
    AvatarNested,
    SwitchToggle,
    Step,
    CustomToast,
    Stepper,
    VerticalStepper,
    Tab,
    Map,
    MarkerInfoWindow,
    Sidebar,
    Hamburger,
    StepLink1,
    StepsWrapper1,
    StepsWrapper2,
    StepLink2,
    Increment,
    Dropzone,
    CustomSelect,
    DragAndDrop,
    FileCard,
    FileThumbnail,
    EmptyDashedCard,
    BadgeLoadingPlaceholder,
    ImageLoadingPlaceholder,
    TextLoadingPlaceholder,
    ElementLoader,
    CommonSidebar,
    CommonHeader,
    AnimateHamburger,
    LazyPublicStorageImage,

    //Inputs
    MsDatePicker,
    TextInput,
    PriceInput,
    PhoneInput,
    UsPhoneInput,
};
